export default __webpack_public_path__ + "static/media/State=Hover.523251b3.svg";